import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const errMsg = (e) => e?.response?.data?.detail || "Terjadi kesalahan, coba lagi";

export async function downloadFile(path, params, fallback) {
  const res = await api.get(path, { params, responseType: "blob" });
  const name = (res.headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || fallback;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}

export const downloadExport = (cat, polda) => downloadFile(`/export/${cat}`, polda ? { polda } : {}, `${cat}.xlsx`);

export const downloadReport = (params) => downloadFile("/report", params, "laporan.pdf");

export const ROLE_LABEL = {
  admin: "Admin Subbagrenmin",
  staf: "Staf Subbagrenmin",
  polda: "Ditressiber Polda",
};
